import {FormGroup, ValidatorFn} from '@angular/forms';


export function MustMatch(controlName: string, matchingControlName: string): ValidatorFn | null {
    return (formGroup: FormGroup): { [key: string]: any } | null => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value?.toLowerCase() !== matchingControl.value?.toLowerCase()) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    };
}
